import styled, { css } from "styled-components";
import { Link } from "@viagogo/core/ui";
import { Image } from "src/website-apps/shared/components/image";

export const StyledCompactTopResultGrid = styled.ul`
  display: grid;
  gap: ${({ theme }) => theme.spacing(2)};
  grid: repeat(1, auto) / repeat(auto-fill, minmax(330px, 1fr));
`;

export const PaddedWrapper = styled.div<{ $removeSideSpacing?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: ${(props) => (props.$removeSideSpacing ? props.theme.spacing(2, 0) : props.theme.spacing(2, 4, 2, 4))};
  max-width: 1200px;
  margin: auto;
`;

export const StyledTopResultCard = styled(Link)<{ $searchResults?: boolean; $searchRedesign?: boolean }>`
  background-color: ${(props) => props.theme.palette.surfacePrimary};
  display: block;
  position: relative;
  transition: background 0.2s ease-in-out;
  user-select: none;
  ${(props) =>
    props.$searchResults
      ? css`
          width: 100%;
        `
      : css`
          width: auto;
        `}
  height: ${(props) => props.theme.spacing(20)};
  ${(props) =>
    props.$searchRedesign
      ? css`
          border-bottom: none;
          border-top-left-radius: ${props.theme.spacing(3)};
          border-top-right-radius: ${props.theme.spacing(3)};
        `
      : css`
          border: 1px solid ${props.theme.palette.neutralSecondaryActive};
          border-radius: 12px;
        `}
  &:hover {
    background-color: ${(props) => props.theme.palette.brandSecondary};
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.25);

    [data-icon-wrapper] {
      width: 16px;
    }
  }

  [data-icon-wrapper] {
    width: 0;
    overflow: hidden;
    transition: width 0.3s ease;
  }
`;

export const SimpleStyledPerformerName = styled.p`
  color: ${(props) => props.theme.colors.textStrong};
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  display: inline;
`;

const TopMatchCarouselRedesignWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: ${(props) => props.theme.spacing(8)};
  @media ${({ theme: { media } }) => media.phone} {
    overflow: scroll;
  }
`;

const StyledLink = styled(Link)`
  @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
    width: 33%;
  }
`;

const NewCategoryItem = styled.div`
  height: fit-content;
  padding-bottom: ${(props) => props.theme.spacing(2.5)};
`;

const StyledImage = styled(Image)`
  width: 240px;
  object-fit: cover;
  border-radius: ${(props) => props.theme.borderRadius.m};
  @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
    width: 100%;
  }
`;

const StyledImageContainer = styled.div<{ size: { width: number; height: number } }>`
  border-radius: ${(props) => props.theme.borderRadius.m};
  height: ${(props) => `${String(props.size.height)}px`};
  overflow: hidden;
  width: ${(props) => `${String(props.size.width)}px`};

  @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
    width: 100%;
  }
`;

export const TopResultDemotionWrapper = styled.div`
  ${TopMatchCarouselRedesignWrapper} {
    @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
      gap: ${(props) => props.theme.spacing(8)};
    }
    @media ${({ theme: { media } }) => media.phone} {
      gap: ${(props) => props.theme.spacing(4)};
    }
  }

  ${StyledLink} {
    @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
      width: 235px;
    }
    @media ${({ theme: { media } }) => media.phone} {
      width: 140px;
    }
  }

  ${NewCategoryItem} {
    @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
      width: 235px;
    }
    @media ${({ theme: { media } }) => media.phone} {
      width: 140px;
    }
  }

  ${StyledImage} {
    @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
      width: 235px;
      height: 150px;
    }
    @media ${({ theme: { media } }) => media.phone} {
      width: 140px;
      height: 120px;
    }
  }

  ${StyledImageContainer} {
    @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
      width: 235px;
      height: 150px;
    }
    @media ${({ theme: { media } }) => media.phone} {
      width: 140px;
      height: 120px;
    }
  }
`;
